var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 24.7916L16.4062 17.4999L10.9375 10.2083",
    stroke: "#FF0099",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_133_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9375 24.7916L25.4062 17.4999L19.9375 10.2083",
    stroke: "#FF0099",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 26.25,
    fill: "white",
    transform: "matrix(0 1 -1 0 26.25 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_133_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 26.25,
    fill: "white",
    transform: "matrix(0 1 -1 0 35.25 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.7ed182333f1f143a0a94ff0f93f34c9c.svg";
export { ForwardRef as ReactComponent };